import { MOKA_SERVICE_HOST } from '../../constants';

export const V1_ADVANCED_INVENTORY_SETTINGS = `${MOKA_SERVICE_HOST}/business-service/v1/businesses/setting-inventory`;
